var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-pagination',{attrs:{"total":_vm.count,"page-total":_vm.pageTotal,"per-page":_vm.perPage,"page":_vm.page},on:{"changePage":_vm.changePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }